<template>
  <SelectField
    required
    name="adult"
    label="Are you an adult?"
    placeholder="Select"
    :options="['yes', 'no']"
  />
</template>

<script lang="ts">
import { computed } from "vue";
import { useCookies } from "@vueuse/integrations/useCookies";

const ageVerificationCookieId = "age-verification";

export function useAgeVerification() {
  const cookie = useCookies([ageVerificationCookieId]);

  const isAdult = computed<boolean | null>({
    get: () => cookie.get<boolean | null>(ageVerificationCookieId) ?? null,
    set: (value) => cookie.set(ageVerificationCookieId, value),
  });

  return isAdult;
}
</script>

<script setup lang="ts">
import SelectField from "./SelectField.vue";
</script>
